<template>
  <div>
      <h2>Profilo Ufficio Attivo</h2>
    <hr>
    <card>
        <h3 style="color:#00467f">Gruppi</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="gruppo_fisico">Gruppo Fisico</label>
                    <select v-model="gruppo_fisico" class="form-control">
                        <option>..</option>
                        <option>..</option>
                    </select>
                </div>
                <div class="form-group col-md-6">
                    <label for="gruppo_logico">Gruppo Logico</label>
                    <select v-model="gruppo_logico" class="form-control">
                        <option>..</option>
                        <option>..</option>
                    </select>
                </div>
            </div>
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriGruppi()" style="margin-top: 10px;background:#00467f">Salva</button>
        
        <h3 style="margin-top:20px;color:#00467f">Dati Ufficio</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="p_iva">Ufficio/Partita IVA</label>
                    <input type="text" class="form-control" v-model="p_iva" placeholder="p_iva">
                </div>
                <div class="form-group col-md-4">
                    <label for="denominazione">Denominazione</label>
                    <input type="text" class="form-control" v-model="denominazione" placeholder="denominazione">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="indirizzo">Indirizzo</label>
                    <input type="text" class="form-control" v-model="indirizzo" placeholder="indirizzo">
                </div>
                <div class="form-group col-md-6">
                    <label for="comune">Comune</label>
                     <select v-model="comune" class="form-control">
                        <option>..</option>
                        <option>..</option>
                    </select>
                </div>
            </div>
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriUfficio()" style="margin-top: 10px;background:#00467f">Salva</button>
        
        <h3 style="margin-top:20px;color:#00467f">Impostazioni</h3>
        <hr>
        <form>
            <div class="form-row float-left">
                <div class="form-group col-md-6">
                    <label for="bilinguismo"><input type="checkbox" class="form-control" v-model="bilinguismo">Bilinguismo per Stampe</label>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="nome">Responsabile della protezione dei dati</label>
                    <input type="text" class="form-control" v-model="responsabile_protezione" placeholder="responsabile della protezione dei dati">
                </div>
            </div>
            
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriImpostazioni()" style="margin-top: 10px;background:#00467f">Salva</button>
       
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
export default {
    components: {
        Card
    },

    data() {
        return {
            // GRUPPI
            gruppo_fisico: null,
            gruppo_logico: null,
            // DATI UFFICIO
            p_iva: null, 
            denominazione: null,
            indirizzo: null,
            comune: null,
            // IMPOSTAZIONI
            bilinguismo: null,
            responsabile_protezione: null,
        }
    },
    computed: {},

    methods: {
        salvaValoriGruppi: async function() {
            let dati = [{ GRUPPO_FISICO: this.gruppo_fisico, GRUPPO_LOGICO: this.gruppo_logico }]
            /*
            let salvaValori = [];
            await axios.post(
                this.urlRichieste + '', dati,
                withCredentials: true,
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            )   
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
            */
       },

       salvaValoriUfficio: async function() {
           let dati = [{ UFFICIO_PIVA: this.p_iva, DENOMINAZIONE: this.denominazione, INDIRIZZO: this.indirizzo, COMUNE: this.comune}]
          /*
            let salvaValori = [];
            await axios.post(
                this.urlRichieste + '', dati,
                withCredentials: true,
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            )   
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
             */
       },

        salvaValoriImpostazioni: async function() {
            let dati = [{ BILINGUISMO: this.bilinguismo, RESPONSABILE_PROTEZIONE: this.responsabile_protezione }]
            /*
             let salvaValori = [];
            await axios.post(
                this.urlRichieste + '', dati,
                withCredentials: true,
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${token}`
                }
            )   
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                errore = error.response.status;
                }
            });
             */
        },
    

        main: function() {
            this.caricaSoggetti();
        },
    },
    
    mounted() {
        this.main();
    } 

};
</script>
<style>
.row-color:hover {
  background-color: #00467f53;
}
</style>
